import Quill from 'quill';

const Embed = Quill.import('blots/embed');

class MentionBlot extends Embed {
    static create(data) {
        let node = super.create();
        node.innerHTML = `@${data.value}`;
        node.dataset.id = data.id;
        node.dataset.value = data.value;
        return node;
    }

    static value(node) {
        return {
            id: node.dataset.id,
            value: node.dataset.value,
        };
    }
}

MentionBlot.blotName = 'mention';
MentionBlot.tagName = 'span';
MentionBlot.className = 'mention';

Quill.register(MentionBlot);
